import { render, staticRenderFns } from "./right_info.vue?vue&type=template&id=624fa2e2"
import script from "./right_info.vue?vue&type=script&lang=js"
export * from "./right_info.vue?vue&type=script&lang=js"
import style0 from "./right_info.vue?vue&type=style&index=0&id=624fa2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports